import { object, string, array, boolean } from 'zod'
import type { NavigateBySportsProps } from 'src/components/department/types/navigate-by-sport'

export function useNavigateBySports() {
  function validateProps(props: NavigateBySportsProps) {
    try {
      const schema = object({
        enableSession: boolean(),
        sessionTitle: object({
          textColor: string(),
          text: string(),
        }),
        image: object({
          mobile: string(),
          tablet: string(),
          desktop: string(),
        }),
        sports: array(
          object({
            linkUrl: string(),
            text: string(),
          })
        ),
      })

      schema.parse(props)

      return true
    } catch (err) {
      console.warn('Invalid NavigateBySports data')

      return false
    }
  }

  return {
    validateProps,
  }
}
